import InvestmentFilesCollection from "./InvestmentFilesCollection"

export default InvestmentFilesCollection
